export default __webpack_public_path__ + "static/hiring_img-d2f4d14cddf1a6313933830bbd4ed67c.png";